import * as React from 'react';
import { CreateButton } from '@watcherr/ui';
import { useNavigate } from 'react-router-dom';

const HealthcareProviderCreateContainer: React.FC = () => {
  const navigate = useNavigate();
  return <CreateButton atBottom onClick={() => navigate('/healthcare-providers/create')} />;
};
export default HealthcareProviderCreateContainer;
